import { render, staticRenderFns } from "./ServiceSummaryForm.vue?vue&type=template&id=0bbb1d4a&"
import script from "./ServiceSummaryForm.vue?vue&type=script&lang=js&"
export * from "./ServiceSummaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports